import './ccf-phone-ringing-icon.module.scss';

import { SvgIcon, SvgIconProps } from '@mui/material';
/* eslint-disable-next-line */
export interface CcfPhoneRingingIconProps extends SvgIconProps { }

/**
 * Component display phone ringing icon when contactStatus is rining
 * @param props -CcfPhoneRingingIconProps
 * @returns phone ringing svg icon
 * @example - <CcfPhoneRingingIcon/>
 */
export function CcfPhoneRingingIcon(props: CcfPhoneRingingIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="Tile_Ringing" data-name="Tile Ringing">
        <g id="Group_119163" data-name="Group 119163" transform="translate(-316.441 -146)">
          <path id="Path_12738" data-name="Path 12738" d="M-21.292-154.185c-.025-.122-.118-.28-.682-.682a10.835,10.835,0,0,0-4.09-2.045,19.063,19.063,0,0,0-4.772-.682,22.916,22.916,0,0,0-5.454.682,10.836,10.836,0,0,0-4.09,2.045c-.564.4-.657.56-.682.682a11.117,11.117,0,0,0,0,2.727c.068.543.152.435,1.363.682,1.64.334,3.632.177,3.409-.682,0,0,.021-1.248,0-1.363s-.616-1.021,0-1.363c.676-.376,2.64-.681,5.454-.682s4.1.306,4.772.682c.616.342.021,1.248,0,1.363s0,1.363,0,1.363c-.224.858,1.769,1.016,3.409.682,1.211-.247,1.3-.138,1.363-.682A11.112,11.112,0,0,0-21.292-154.185Z" transform="translate(357.647 313.824)" />
          <rect id="Rectangle_80337" data-name="Rectangle 80337" width="2.249" height="5.998" rx="1.125" transform="translate(325.048 147)" />
          <rect id="Rectangle_80338" data-name="Rectangle 80338" width="2.249" height="5.998" rx="1.125" transform="translate(334.197 149.088) rotate(30)" />
          <rect id="Rectangle_80339" data-name="Rectangle 80339" width="2.249" height="5.998" rx="1.125" transform="translate(316.201 150.215) rotate(-30)" />
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfPhoneRingingIcon;
